module.exports = __webpack_public_path__ + "static/media/76.16eeab82.jpg";